module.exports = __webpack_public_path__ + "static/img/illust_3_mk.a2ada7ea.svg";